import { render, staticRenderFns } from "./OrganizationVariableList.vue?vue&type=template&id=56a0b092&scoped=true&"
import script from "./OrganizationVariableList.vue?vue&type=script&lang=js&"
export * from "./OrganizationVariableList.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationVariableList.vue?vue&type=style&index=0&id=56a0b092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a0b092",
  null
  
)

export default component.exports